/**
 * webBridge模块
 */

import storage from './storage'
import app2H5 from './app2H5' // APP调用H5
var dsBridge = require('dsbridge')
var u = navigator.userAgent
var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
var that = {}

/**
 * 调用app方法
 * @param  {string} 方法名称
 * @param  {Function} 回调函数
 * @param  {object} 附加数据
 */

that.startPhotoForResult = type => { // new 后期统一用这个
  return new Promise(resolve => {
    if (dsBridge.hasNativeMethod('startPhotoForResult', 'all')) {
      dsBridge.call('startPhotoForResult', type, res => {
        let data = res
        if (typeof res === 'string') {
          data = JSON.parse(data)
        }
        resolve(data)
      })
    } else { // H5 操作
      const Tobase64 = fileObj => {
        const reader = new FileReader()
        reader.readAsDataURL(fileObj)
        reader.onload = function(e) {
          const base64 = e.target.result.split(';base64,')[1]
          resolve({ image: base64 })
        }
      }

      let input = document.createElement('INPUT')
      input.type = 'file'
      input.addEventListener('change', e => {
        Tobase64(e.target.files[0])
      })
      input.click()
      input = null
    }
  })
}

// that.startPhotoForResult = function(type) { // new 后期统一用这个
//   keyAt++
//   if (isAndroid) {
//     app.startPhotoForResult(`${type},${keyAt}`)
//   } else {
//     window.webkit.messageHandlers.startPhotoForResult.postMessage(`${type},${keyAt}`)
//   }
//   return keyAt
// }
that.previewPhoto = url => { // url为src或者base64
  let type
  if (url.indexOf('https://') !== -1 || url.indexOf('http://') !== -1) {
    type = 2
  } else {
    type = 1
    url = url.replace('data:image/png;base64,', '')
  }
  dsBridge.call('viewPhoto', `${type},${url}`)
}
that.logoutApp = function() {
  storage.clear('_userInfo')
  storage.clear('_auth')
  dsBridge.call('logout')
  dsBridge.call('goLogin')
}
that.getAppUserInfo = () => {
  let userInfo = JSON.parse(dsBridge.call('getUserInfo'))
  const getCookie = name => {
    const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    let arr = null
    if (document.cookie.match(reg)) {
      arr = document.cookie.match(reg)
      return { token: unescape(arr[2]) }
    } else {
      return {}
    }
  }
  if (!userInfo.token) {
    userInfo = getCookie('token')
  }
  return JSON.stringify(userInfo)
}
that.getVersionName = () => {
  return dsBridge.call('getVersionName')
}
that.getUpdateRedDotStatus = () => {
  return new Promise(resolve => {
    dsBridge.call('getUpdateRedDotStatus', '', res => {
      resolve(res)
    })
  })
}
that.checkUpdate = () => {
  dsBridge.call('checkUpdate')
}
that.scanPlateNumber = (data = {}) => {
  return new Promise((resolve, reject) => {
    dsBridge.call('scanPlateNumber', JSON.stringify(data), res => {
      if (res) {
        resolve(res)
      } else {
        reject()
      }
    })
  })
}
that.scanVinCode = (data = {}) => {
  return new Promise((resolve, reject) => {
    dsBridge.call('scanVinCode', JSON.stringify(data), res => {
      if (res) {
        resolve(res)
      } else {
        reject()
      }
    })
  })
}
that.pickAddress = data => {
  return new Promise(resolve => {
    dsBridge.call('pickAddress', JSON.stringify(data), res => {
      resolve(res)
    })
  })
}
that.scanBarCode = data => {
  return new Promise((resolve, reject) => {
    dsBridge.call('scanBarCode', JSON.stringify(data), res => {
      if (res) {
        resolve(res)
      } else {
        reject()
      }
    })
  })
}
that.OCRCollect = (data = {}) => {
  return new Promise(resolve => {
    dsBridge.call('OCRCollect', JSON.stringify(data), res => {
      resolve(res)
    })
  })
}

that.setPasteboardString = data => {
  dsBridge.call('setPasteboardString', data)
}
that.phoneBomb = (data = '2') => {
  // dsBridge.call('phoneBomb', data + '')
}
that.showWaterMarker = text => {
  dsBridge.call('showWaterMarker', text)
}
that.openUrl = data => { // 新打开一个webview
  if (isAndroid) {
    window.open(data.url)
  } else {
    dsBridge.call('openUrlWithNav', JSON.stringify(data))
  }
}
that.openUrlWithNav = data => { // 打开pdf等等
  if (isAndroid) {
    location.href = data.url
  } else {
    dsBridge.call('openUrlWithNav', JSON.stringify(data))
  }
}

that.openUrlWithNavNew = data => { // 打开pdf等等
  // if (isAndroid) {
  //   location.href = data.url
  // } else {
  // }
  dsBridge.call('openUrlWithNav', JSON.stringify(data))
}

that.appShare = data => {
  const str =
    '【故障车辆】' + data.plate_number + '\n' +
    '【故障车型】' + data.car_type + '\n' +
    '【故障地点】' + data.fault_address + '\n' +
    '【故障城市】' + data.fault_city + '\n' +
    '【报修人员】' + data.submitter + '\n' +
    '【联系电话】' + data.submitter_tel + '\n' +
    '【所属公司】' + data.operator_name + '\n' +
    '【所属客户】' + data.customer_name + '\n' +
    '【服务类型】' + data.agreement + '\n' +
    '【故障现象】' + data.failure_types + '\n' +
    '【故障描述】' + data.fault_description
  dsBridge.call('share', str)
}

that.CreateShare = data => {
  dsBridge.call('share', data)
}
that.onBackPressed = () => {
  window.close()
}
that.checkGps = () => {
  return new Promise(resolve => {
    dsBridge.call('checkGpsStatus', '', res => {
      resolve(res)
    })
  })
}
that.setUserInfo = data => { // 供chorme调试调用
  storage.put('_userInfo', data)
}
that.getCacheSize = () => {
  return dsBridge.call('getCacheSize')
}
that.clearH5Cache = () => {
  dsBridge.call('clearH5Cache')
}

that.speak = data => {
  dsBridge.call('speak', data)
}

that.setStatusBarColor = (data = '16D1A4') => {
  dsBridge.call('setStatusBarColor', data)
}
that.setScreenBrightness = (data = '1') => {
  dsBridge.call('setScreenBrightness', data)
}
that.getNativeLocation = () => {
  return new Promise(resolve => {
    dsBridge.call('getNativeLocation ', '', res => {
      resolve(res)
    })
  })
}
that.hasNativeMethod = (name = '') => {
  return dsBridge.hasNativeMethod(name)
}
that.previewFile = (filePath) => {
  let str = ''
  var hostName = window.location.hostname // 域名
  if (hostName.indexOf('.dev.') != -1) {
    str = 'https://webhub.dev.dstzc.com'
  } else if (hostName.indexOf('.test.') != -1) {
    str = 'https://webhub.test.dstzc.com'
  } else if (hostName.indexOf('.sit.') != -1) {
    str = 'https://webhub.sit.dstzc.com'
  } else if (hostName.indexOf('.demo.') != -1) {
    str = 'https://webhub.demo.dstzc.com'
  } else {
    str = 'https://webhub.dstcar.com'
  }
  const strPath = filePath.split('?')[0]
  const url = strPath.split('.com/')[1]
  that.openUrl({ url: `${str}/publicweb/#/previewFile/index?filePath=${url}` })
}

// 打开录音页面
that.openRecordPage = (data = {}) => {
  const res = dsBridge.call('openRecordPage', data)
  if (res) {
    try {
      return JSON.parse(res)
    } catch (error) {
      return {
        status: false,
        msg: '唤起录音失败，数据格式转换失败'
      }
    }
  }
  return {
    status: false,
    msg: '唤起录音失败,请重试'
  }
}

// 获取录音状态
that.getRecordStatus = () => {
  const res = dsBridge.call('getRecordStatus')
  if (res) {
    try {
      return JSON.parse(res)
    } catch (error) {
      return {}
    }
  }
  return {}
}

// 继续录音
that.resumeRecord = () => {
  const res = dsBridge.call('resumeRecord')
  if (res) {
    try {
      return JSON.parse(res)
    } catch (error) {
      return {}
    }
  }
  return {}
}

// 暂停录音
that.pauseRecord = () => {
  const res = dsBridge.call('pauseRecord')
  if (res) {
    try {
      return JSON.parse(res)
    } catch (error) {
      return {}
    }
  }
  return {}
}

// 停止录音
that.stopRecord = () => {
  const res = dsBridge.call('stopRecord')
  if (res) {
    try {
      return JSON.parse(res)
    } catch (error) {
      return {}
    }
  }
  return {}
}

// 打开录音文件管理页
that.openRecordFiles = () => dsBridge.call('openRecordFiles')

// 打开录音文件选择页(异步)
that.pickRecordFiles = (data = {}) => {
  return new Promise((resolve, reject) => {
    dsBridge.call('pickRecordFiles', data, res => {
      if (res) {
        try {
          const data = JSON.parse(res)
          resolve(data)
        } catch (error) {
          reject()
        }
      } else {
        reject()
      }
    })
  })
}

// 获取所有录音文件列表(异步)
that.getRecordFiles = (data = {}) => {
  return new Promise((resolve) => {
    const res = dsBridge.call('getRecordFiles', data)
    if (!res) {
      resolve([])
    }
    if (res) {
      try {
        const data = JSON.parse(res)
        resolve(data)
      } catch (error) {
        resolve([])
      }
    }
  })
}

app2H5(dsBridge)
window.webBridge = that

// 显示水印
try {
  const userObj = JSON.parse(webBridge.getAppUserInfo())
  webBridge.showWaterMarker(`${userObj.realname} ${userObj.jobNumber}`)
} catch (e) {
  console.log(e)
}

that.scanVinOrPlateNumber = (data = {}) => {
  return new Promise((resolve, reject) => {
    dsBridge.call('scanVinOrPlateNumber', JSON.stringify(data), res => {
      if (res) {
        resolve(res)
      } else {
        reject()
      }
    })
  })
}

export default window.webBridge

// });



// WEBPACK FOOTER //
// ./src/lib/webBridge.js